import { useQuery } from '@tanstack/react-query';

import { getIssuer } from '@arrived/api_v2';
import { Issuer } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { issuerQueryKey } from './issuers.keys';

export function useGetIssuerQuery(issuerId: Issuer['id'], options?: UseQueryOptions<Issuer>) {
  return useQuery(issuerQueryKey(issuerId), async () => getIssuer(issuerId), {
    staleTime: MAX_STALE_TIME,
    ...options,
  });
}
